import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EventScope from 'owa-service/lib/contract/EventScope';
import { getEditMenuItems as getEditMenuItemsCommon } from 'owa-event-context-menu';

export default function getEditMenuItems(
    item: CalendarEvent,
    composeEntrySource: string,
    onEditClickedCallback: (
        event: CalendarEvent,
        entrySource: string,
        eventScope: EventScope
    ) => void
): IContextualMenuItem[] {
    return getEditMenuItemsCommon(
        item,
        createOnEditClicked(item, composeEntrySource, onEditClickedCallback)
    );
}

function createOnEditClicked(
    event: CalendarEvent,
    entrySource: string,
    onEditClickedCallback: (
        event: CalendarEvent,
        entrySource: string,
        eventScope: EventScope
    ) => void
): (eventScope: EventScope) => void {
    return (eventScope: EventScope) => {
        onEditClickedCallback(event, entrySource, eventScope);
    };
}
